<template>
  <div id="contenedor-listado-licitacion-apertura-propuestas-mobile">
    <template v-for="(participante, index) in licitacionParticipantes">
      <v-card :key="index" class="mb-3">
        <v-card-title
        v-if="mixValidaScopesActions(2)">
          {{ participante.contratista.nombreRazonSocial }}
          <v-spacer></v-spacer>
          <v-btn
            v-if="!participante.aperturaPropuestas"
            icon
            @click="nuevaPropuestaParticipante(participante)"
          >
            <v-icon>mdi-folder-plus</v-icon>
          </v-btn>
          <v-btn
            v-else
            icon
            @click="editarPropuestaParticipante(participante)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-card-title>
      </v-card>
    </template>
  </div>
</template>

<script>
import LICITACION_PARTICIPANTES from '@/graphql/querys/administracion/licitaciones/participantes/licitacionParticipantes.gql';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoLicitacionAperturaPropuestasMobile',
  data() {
    return {};
  },
  apollo: {
    licitacionParticipantes: {
      query: LICITACION_PARTICIPANTES,
      variables() {
        return {
          idLicitacion: this.$route.params.idLicitacion,
        };
      },
    },
  },
  computed: {
    listado() {
      return [
        { fecha: '01-01-2021' },
        { fecha: '01-02-2021' },
        { fecha: '01-03-2021' },
      ];
    },
  },
  methods: {
    nuevaPropuestaParticipante(participanteLicitacion) {
      eventBus.$emit('agregar-propuesta-participante', participanteLicitacion);
    },
    editarPropuestaParticipante(participanteLicitacion) {
      eventBus.$emit('editar-propuesta-participante', participanteLicitacion);
    },
  },
};
</script>

<style lang="scss">
</style>
